import { PER_PAGE } from "../../components/constants";
import { CLOSE_LOADER, OPEN_LOADER } from "../actions/appActions";
import { PAY_NOW,PAYMENTS_DATA, PYAMENT_STATUS_DETAILS, RESET_PAYMENTS_DATA } from "../actions/paymentAction";
const initialState = {
    paymentDetails: {},
    loader: false,
    paymentsData:[],
    pagination: {
      perPage: PER_PAGE,
      totalItems: 0,
      currentPage: 0,
      totalPages:0
    },

  };
  
  export const paymentReducer = (state=initialState, action) => {
    switch (action.type) {
      case PAY_NOW:
        return {
          ...state,
        };
      case OPEN_LOADER: 
        return {
          ...state,
          loader: action.payload
        }
      case CLOSE_LOADER: 
        return {
          ...state,
          loader: action.payload
        }
      case PYAMENT_STATUS_DETAILS: 
        return {
          ...state,
          paymentDetails: action.payload
        }
      case PAYMENTS_DATA: 
        return {
          ...state,
          paymentsData: state.paymentsData.concat(action.payload.paymentData),
          pagination:{
            totalItems: action.payload.totalItems,
            totalPages: action.payload.totalPages,
            currentPage: action.payload.currentPage,
            perPage:PER_PAGE
          }
        }
        case RESET_PAYMENTS_DATA: 
        return {
          ...state,
          paymentsData: action.payload,
          pagination:{
            totalItems: 0,
            totalPages: 0,
            currentPage: 0,
            perPage:PER_PAGE
          }
        }
      default:
        return state;
    }
  };
  